import {
  lucideArrowLeft,
  lucideCalendar,
  lucideCalendarClock,
  lucideCalendarDays,
  lucideCamera,
  lucideCheck,
  lucideChevronDown,
  lucideChevronLeft,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideCircleX,
  lucideCookie,
  lucideEye,
  lucideEyeOff,
  lucideFileText,
  lucideGlobe,
  lucideHandCoins,
  lucideInfo,
  lucideKeyRound,
  lucideLink,
  lucideLeaf,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucideMapPin,
  lucideMessageCircle,
  lucideMessageSquareWarning,
  lucidePartyPopper,
  lucidePhone,
  lucideRefreshCw,
  lucideReceiptText,
  lucideShoppingBasket,
  lucideSmartphone,
  lucideStar,
  lucideTrophy,
  lucideUserCheck,
  lucideUser,
  lucideUsers,
  lucideUserX,
  lucideWifi,
  lucideX,
  lucideGift,
  lucidePackageOpen,
  lucideHourglass,
  lucidePen,
  lucideCirclePlus,
} from '@ng-icons/lucide';

export const ICONS_MAP = {
  lucideArrowLeft,
  lucideCalendar,
  lucideCalendarClock,
  lucideCalendarDays,
  lucideCamera,
  lucideCheck,
  lucideCookie,
  lucideChevronDown,
  lucideChevronLeft,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideCircleX,
  lucideEye,
  lucideEyeOff,
  lucideFileText,
  lucideGlobe,
  lucideHandCoins,
  lucideInfo,
  lucideKeyRound,
  lucideLink,
  lucideLeaf,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucideMapPin,
  lucideMessageCircle,
  lucideMessageSquareWarning,
  lucidePartyPopper,
  lucidePhone,
  lucideRefreshCw,
  lucideReceiptText,
  lucideShoppingBasket,
  lucideSmartphone,
  lucideStar,
  lucideTrophy,
  lucideUserCheck,
  lucideUser,
  lucideUsers,
  lucideUserX,
  lucideWifi,
  lucideX,
  lucideGift,
  lucidePackageOpen,
  lucideHourglass,
  lucidePen,
  lucideCirclePlus,
};

type LucideIcon = keyof typeof ICONS_MAP;

export const ICONS_NAME_MAP = {
  'arrow-left': 'lucideArrowLeft',
  calendar: 'lucideCalendar',
  'calendar-clock': 'lucideCalendarClock',
  'calendar-days': 'lucideCalendarDays',
  camera: 'lucideCamera',
  check: 'lucideCheck',
  cookie: 'lucideCookie',
  'chevron-down': 'lucideChevronDown',
  'chevron-left': 'lucideChevronLeft',
  'circle-alert': 'lucideCircleAlert',
  'circle-check': 'lucideCircleCheck',
  'circle-x': 'lucideCircleX',
  email: 'lucideMail',
  'eye-off': 'lucideEyeOff',
  eye: 'lucideEye',
  'file-text': 'lucideFileText',
  info: 'lucideInfo',
  'key-round': 'lucideKeyRound',
  link: 'lucideLink',
  leaf: 'lucideLeaf',
  'lock-keyhole': 'lucideLockKeyhole',
  'mail-check': 'lucideMailCheck',
  'map-pin': 'lucideMapPin',
  'message-important': 'lucideMessageSquareWarning',
  messages: 'lucideMessageCircle',
  phone: 'lucidePhone',
  'party-popper': 'lucidePartyPopper',
  'refresh-cw': 'lucideRefreshCw',
  'receipt-text': 'lucideReceiptText',
  'shopping-basket': 'lucideShoppingBasket',
  smartphone: 'lucideSmartphone',
  star: 'lucideStar',
  trophy: 'lucideTrophy',
  'user-check': 'lucideUserCheck',
  user: 'lucideUser',
  users: 'lucideUsers',
  'user-x': 'lucideUserX',
  website: 'lucideGlobe',
  x: 'lucideX',
  wifi: 'lucideWifi',
  'hand-coins': 'lucideHandCoins',
  gift: 'lucideGift',
  'package-open': 'lucidePackageOpen',
  hourglass: 'lucideHourglass',
  pen: 'lucidePen',
  'circle-plus': 'lucideCirclePlus',
  confetti: 'lucidePartyPopper',
  'delete-account': 'lucideUserX',
  plant: 'lucideLeaf',
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS_NAME_MAP;
